import { useState } from 'react';
import { useApi } from '#shared/providers/Api';
import { useAccountingSoftware } from '../AccountingSoftwareContext';

export default function useFetchContactPaymentMethods() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);
  const { account: response } = useAccountingSoftware();
  const clientAccountsEnabled = Boolean(response.ClientAccountsEnabled);

  // Called per contact — callers keep the returned PaymentMethods. Both routes
  // read the same VIOClientAccounts entity with the same ID; which one is
  // allowed depends on the account's ClientAccountsEnabled flag (the other
  // route rejects the call), so the flag picks the endpoint — mirroring
  // usePaymentMethods.fetchMethods.
  async function fetchContactPaymentMethods(contactClientAccountId: string) {
    try {
      setFetching(true);

      const res = clientAccountsEnabled
        ? await api.fetchClientAccountPaymentMethods({ ClientAccountID: contactClientAccountId })
        : await api.fetchContactPaymentMethods({ ContactID: contactClientAccountId });

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, fetchContactPaymentMethods };
}
